import { useQuery, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { layoutQueryKeys } from "./layoutQueryKeys";

export function useLayouts() {
  const { layoutService } = useDomainServices();
  const { currentOrganization } = useAuth();

  return useQuery({
    queryKey: layoutQueryKeys.lists(),
    queryFn: async ({ signal }) => {
      if (currentOrganization === null) {
        return Promise.reject(new Error("CurrentOrganization is not set"));
      }

      return layoutService.getLayoutsForOrg(currentOrganization.org_id, {
        abortSignal: signal,
      });
    },
    select: (data) => {
      return data.items.flatMap((layout) => layout);
    },
  });
}

export function usePrefetchLayouts() {
  const queryClient = useQueryClient();
  const { layoutService } = useDomainServices();
  const { currentOrganization } = useAuth();

  return function prefetchLayouts(): Promise<void> {
    if (currentOrganization === null) {
      return Promise.reject(new Error("CurrentOrganization is not set"));
    }

    return queryClient.prefetchQuery({
      queryKey: layoutQueryKeys.lists(),
      queryFn: async ({ signal }) => {
        return layoutService.getLayoutsForOrg(currentOrganization.org_id, {
          abortSignal: signal,
        });
      },
    });
  };
}
